import { observable, action, computed } from 'mobx';
import { arrDiff } from '../utils/util';
import commentV2Api, { setCommentListCanUserCache } from '../actions/commentv2';
import RootStore from './RootStore';
import { IResult } from '../global';
import {
  IComment,
  ICommentType
} from '../components/ComponentCommentList/AllForCommentList';

import {
  ICommentGift,
  ICommentEmotion
} from '../components/ComponentCommentSend/AllForCommentSend';

export default class CommentV2Store {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    this.rootStore.imStore!.addMessageListener('text', this.onMessage);
    this.rootStore.imStore!.addMessageListener(
      'redpackage',
      this.onRedpackMessage
    );
    this.rootStore.imStore!.addMessageListener('emotion', this.onMessage);
    this.rootStore.imStore!.addMessageListener('image', this.onMessage);
    this.rootStore.imStore!.addMessageListener('file', this.onMessage);
    this.rootStore.imStore!.addMessageListener('gift', this.onMessage);
    this.rootStore.imStore!.addMessageListener('question', this.onMessage);
    this.rootStore.imStore!.addMessageListener('html', this.onMessage);
    this.rootStore.imStore!.addMessageListener('vote', this.onMessage);
    this.rootStore.imStore!.addMessageListener(
      'newuser',
      this.onNewUserMessage
    );

    this.rootStore.imStore!.addMessageListener(
      'comment_hide',
      this.onMessageHide
    );
  }

  @observable messages = [] as IComment[];
  @observable replyTotal = {} as {
    [key: string]: number;
  };
  @observable total = 0;
  @observable filter = 'last';

  @observable giftList = [] as ICommentGift[];
  @observable emotionList = null as ICommentEmotion[] | null;

  @observable isblock = false;

  lastContent = '';
  isLoading = false;
  finalComment = false;
  onlypage = false;

  @action setIsBlock = (status: boolean) => {
    this.isblock = status;
  };

  @action setFilter = (type: string) => {
    this.filter = type;
  };

  @computed get loadedMessagesLength() {
    let t = this.messages.length;

    this.messages.forEach((it: IComment) => {
      if (it && it.replylist && it.replylist.length) {
        t += it.replylist.length;
      }
    });
    return t;
  }

  // @computed get loadedMessagesLength() {
  //   console.log(this.messages.length);
  //   return this.messages.length;
  // }

  @computed get formatMessages() {
    // 首先一定要置顶
    let format = [...this.messages];

    if (this.filter == 'question') {
      format = format.filter((it: IComment) => {
        return it && it.type == 'question';
      });
    } else {
      format.sort((a: IComment, b: IComment) => {
        if (Number(a.is_top) == Number(b.is_top)) {
          if (this.filter == 'last') {
            return b.id - a.id;
          }
          if (this.filter == 'early') {
            return a.id - b.id;
          }
        }
        return Number(b.is_top) - Number(a.is_top);
        // if (a && Number(a.is_top)) {
        //   return -1;
        // }
        // else if(b && Number(b.is_top)) {
        //   return -1;
        // } else if (this.filter == 'last') {
        //   return Number(a.id) > Number(b.id) ? -1 : 1;
        // } else if (this.filter == 'early') {
        //   return Number(a.id) > Number(b.id) ? 1 : -1;
        // }
      });
    }

    return format;
  }

  fetchGift = (galleryid?: number) => {
    galleryid = galleryid || window.gallery.id;
    return commentV2Api.giftlist(galleryid).then(
      action((res: IResult) => {
        if (res && res.code == 200) {
          let { data } = res;
          let { gift_detail } = data;
          if (gift_detail) {
            this.giftList = gift_detail as ICommentGift[];
          }
        }

        return res;
      })
    );
  };

  fetchEmotion = (galleryid?: number) => {
    galleryid = galleryid || window.gallery.id;
    return commentV2Api.emotionlist(galleryid).then(
      action((res: IResult) => {
        if (res && res.code == 200) {
          let { data } = res;
          let { emotion_detail } = data;
          if (emotion_detail) {
            this.emotionList = emotion_detail as ICommentEmotion[];
          }
        }

        return res;
      })
    );
  };

  onRedpackMessage = (data: any) => {
    let duration = Math.ceil(Math.random() * 5) * 1000;
    setTimeout(() => {
      this.onMessage(data);
    }, duration);
  };

  @action onMessageHide = (data: any) => {
    if (data) {
      let { status, comment_id, reply_id, gallery_data, video_data } = data;

      if (Number(reply_id)) {
        let index = this.messages.findIndex((it: IComment) => {
          if (it && it.id == Number(reply_id)) {
            return true;
          }
          return false;
        });

        if (index > -1) {
          if (this.messages[index]) {
            if (!this.messages[index].replylist) {
              this.messages[index].replylist = [];
            }

            // @ts-ignore
            this.messages[index].replylist = this.messages[index]
              .replylist!.map((it: IComment) => {
                if (it.id == comment_id) {
                  return null;
                }
                return it;
              })
              .filter(Boolean);

            if (this.messages[index].replylist!.length == 0) {
              this.messages[index].has_reply = 0;
            }

            this.messages = [...this.messages];
          }
        }
      } else {
        // @ts-ignore
        this.messages = this.messages
          .map((it: IComment) => {
            if (it.id == comment_id) {
              return null;
            }
            return it;
          })
          .filter(Boolean);
      }

      let localStorageCommentMessage = Number(
        window.localStorage.getItem(`comment_message_${window.gallery.id}`) || 0
      );
      window.localStorage.setItem(
        `comment_message_${window.gallery.id}`,
        localStorageCommentMessage + 1 + ''
      );
    }
  };

  @action onMessage = (data: any) => {
    if (this.onlypage) {
      let { gallery_data, video_data } = data;
      let target_gallery = window.pageDetail.data || 0;
      let target_video = window.pageDetail.video_data || 0;
      if (!(gallery_data == target_gallery || video_data == target_video)) {
        return;
      }
    }

    if (data && Number(data.reply_id)) {
      // 这是一个回复
      let index = this.messages.findIndex((it: IComment) => {
        if (it && it.id == Number(data.reply_id)) {
          return true;
        }
        return false;
      });

      if (index > -1) {
        if (this.messages[index]) {
          if (!this.messages[index].replylist) {
            this.messages[index].replylist = [];
            this.messages[index].has_reply = 1;
          }

          this.messages[index].replylist!.unshift(data);

          this.messages = [...this.messages];
        }
      }
    } else {
      this.messages = [data, ...this.messages];

      let event = new Event('comment-messages-change');
      event.data = [data];
      window.dispatchEvent(event);
    }

    this.total = this.total + 1;

    if (data && data.type == 'gift') {
      let giftTransition = new Event('custom-comment-gift-transition');
      giftTransition.data = data;
      window.dispatchEvent(giftTransition);
    }

    window.dispatchEvent(new Event('custom-tab-height-change'));

    let localStorageCommentMessage = Number(
      window.localStorage.getItem(`comment_message_${window.gallery.id}`) || 0
    );
    window.localStorage.setItem(
      `comment_message_${window.gallery.id}`,
      localStorageCommentMessage + 1 + ''
    );
    // }
  };

  onNewUserMessage = (data: any) => {
    if (data && data.type == 'newuser') {
      let newUser = new Event('custom-comment-newuser-transition');

      if (data && data.list && window.userinfo && window.userinfo.nickname) {
        data.list = data.list
          .map((it: any) => {
            if (
              it.nick_name == window.userinfo.nickname &&
              window.userinfo.message_newuser
            ) {
              return null;
            }
            return it;
          })
          .filter(Boolean);
      }

      newUser.data = data;
      window.dispatchEvent(newUser);
    }
  };

  @action clear = () => {
    this.messages = [];
  };

  getHistory = (
    gallery_id: number,
    type: string,
    useLast: boolean = false,
    onlypage: boolean = false
  ) => {
    let lastid = 0;
    this.onlypage = onlypage;

    if (type == 'early') {
      if (useLast) {
        // let right = this.messages.find((it:IComment)=>{
        //   if(it && !it.is_top) {
        //     return true;
        //   }
        //   return false;
        // });
        // lastid = (right && right.id) ? right.id : 0;
        let item = this.messages[this.messages.length - 1];
        if (item) {
          lastid = item.id;
        } else {
          this.finalComment = true;
        }
      } else {
        lastid = 0;
      }
    } else {
      if (useLast) {
        let item = this.messages[this.messages.length - 1];
        if (item) {
          lastid = item.id;
        } else {
          this.finalComment = true;
        }
      } else {
        lastid = Number.MAX_SAFE_INTEGER;
      }
    }

    const useTop = !useLast;
    if (useLast && (this.finalComment || this.isLoading)) {
      return new Promise(resolve => {
        resolve([]);
      });
    } else {
      this.isLoading = true;

      let filter = {};
      if (onlypage) {
        // filter = {
        //   video_data: window.pageDetail.video_data
        //     ? window.pageDetail.video_data
        //     : '',
        //   gallery_data: window.dataDetail ? window.dataDetail.id : ''
        // };
        let video_data = window.pageDetail.video_data
          ? window.pageDetail.video_data
          : '';

        let gallery_data = window.dataDetail ? window.dataDetail.id : '';

        if (video_data) {
          // @ts-ignore
          filter.video_data = video_data;
        }
        if (gallery_data) {
          // @ts-ignore
          filter.gallery_data = gallery_data;
        }
      }

      return commentV2Api.list(gallery_id, type, lastid, useTop, filter).then(
        action((res: IResult) => {
          this.isLoading = false;
          if (res && res.code == 200) {
            let { data } = res;
            if (!useLast) {
              this.total = data.total_number || data.total;
            }

            if (data.total === 0) {
              this.finalComment = true;
            } else {
              this.finalComment = false;
            }
            // let newList = useLast ? [...data.items] : [...this.messages, ...data.items];
            let newList = [...this.messages, ...data.items];
            this.messages = newList;

            let event = new Event('comment-messages-change');
            event.data = [...newList];
            window.dispatchEvent(event);

            // 判断一下是否需要去请求replylist
            let ids = (data.items || [])
              .map((it: IComment) => {
                if (it && Number(it.has_reply)) {
                  return Number(it.id);
                }
                return null;
              })
              .filter(Boolean);

            if (ids && ids.length) {
              this.replylist(ids as number[]);
            }
          }

          return res;
        })
      );
    }
  };

  checkContent = (content: string) => {
    if (content && content == this.lastContent) {
      return false;
    }
    return true;
  };

  post = (data: IComment) => {
    if (data && data.content) {
      if (data.type == ICommentType.TEXT) {
        this.lastContent = data.content;
      }

      let filter = {
        video_data: window.pageDetail.video_data
          ? window.pageDetail.video_data
          : 0,
        gallery_data: window.dataDetail ? window.dataDetail.id : 0
      };

      data = {
        ...data,
        ...filter
      };

      return commentV2Api.post(data).then(
        action((res: IResult) => {
          if (res && res.code == 200) {
            // this.messages = [
            //   res.data,
            //   ...this.messages,
            // ];
          }

          return res;
        })
      );
    }
  };

  @action del = (id: number) => {};

  @action checkblock = () => {
    return commentV2Api.isblock().then(
      action((res: IResult) => {
        if (res && res.code == 200) {
          this.isblock = !res.data;
        }
        return res.data;
      })
    );
  };

  @action replylist = (ids: number[]) => {
    return commentV2Api.replylist(ids).then(
      action((res: IResult) => {
        if (res && res.code == 200) {
          let { data } = res;

          let result = {} as {
            [key: string]: IComment[];
          };

          Object.keys(data).forEach((key: string) => {
            key = String(key);
            result[String(key)] = data[key];
          });

          let newList = [...this.messages];

          for (var i = 0; i < newList.length; i++) {
            let item = newList[i] as IComment;
            if (
              item.id &&
              result[String(item.id)] &&
              result[String(item.id)].length
            ) {
              item.replylist = result[String(item.id)];
              newList[i] = item;
            }
          }

          this.messages = newList;
        }
      })
    );
  };
}
